import { render, staticRenderFns } from "./RziDocumentationItemSection.vue?vue&type=template&id=07cbee71&"
import script from "./RziDocumentationItemSection.vue?vue&type=script&lang=js&"
export * from "./RziDocumentationItemSection.vue?vue&type=script&lang=js&"
import style0 from "./RziDocumentationItemSection.vue?vue&type=style&index=0&id=07cbee71&prod&lang=scss&scoper=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports